// const video_is_youtube = {{ video_is_youtube }};
document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll("img").forEach((img) => {
    img.addEventListener("error", function () {
      const oldBase = "https://app.aico.swiss/19856/storage/";
      const newBase = "https://storage.aico.swiss/19856_61ea09/";

      if (img.src.startsWith(oldBase)) {
        img.src = img.src.replace(oldBase, newBase);
      }
    });
  });
  
  function isIE() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ");
    const trident = ua.indexOf("Trident/");

    return msie > 0 || trident > 0;
  }

  if (!isIE()) return;

  // console.log("product_form_id", product_form_id);
  // console.log("section_id", section_id);

  const hiddenInput = document.querySelector(
    `#${product_form_id} input[name="id"]`
  );
  const noScriptInputWrapper = document.createElement("div");
  const variantPicker = document.querySelector(
    `variant-selects[data-section="${section_id}"]`
  );
  noScriptInputWrapper.innerHTML = document.querySelector(
    `.product-form__noscript-wrapper-${section_id}`
  ).textContent;
  variantPicker.outerHTML = noScriptInputWrapper.outerHTML;

  document
    .querySelector(`#Variants-${section_id}`)
    .addEventListener("change", function (event) {
      hiddenInput.value = event.currentTarget.value;
    });
});
const toggleSwitch = document.getElementById("switch");
const toggleStatus = document.getElementById("switch-status");
function onCheckboxToggle() {
  const isChecked = this.hasAttribute("checked");

  /* 1. Update toggle switch visual state. */

  /* 2. Update toggle switch status text. */

  if (isChecked) {
    document
      .querySelector(`#MainProduct-${section_id}`)
      .classList.remove("full-image");
    document
      .querySelector(`#MainProduct-${section_id}`)
      .classList.remove("dark-bg");
    document.querySelector(".media-container").classList.add("hidden");
    window.pauseAllMedia();
    $(".product__info-wrapper product-info").removeAttr("style");
    $(".media-container").removeClass("no-overlay");
  } else {
    document
      .querySelector(`#MainProduct-${section_id}`)
      .classList.add("full-image");

    document
      .querySelector(`#MainProduct-${section_id}`)
      .classList.add("dark-bg");
    document.querySelector(".media-container").classList.remove("hidden");

    const section = document.getElementById(`shopify-section-${section_id}`);
    section
      .querySelectorAll("deferred-media")
      .forEach((media) => media.loadContent());
  }

  const iframe = document.getElementById("ytplayer");
  const wistiaVideo = video_is_youtube ? null : Wistia.api(`${video_id}`);

  if (iframe) {
    if (isChecked) {
      iframe.src = iframe.src.replace(/autoplay=1/, "autoplay=0"); // Change autoplay=1 to autoplay=0 in the iframe src
    } else {
      iframe.src = iframe.src.replace(/autoplay=0/, "autoplay=1"); // Change autoplay=0 to autoplay=1 in the iframe src
    }
  } else if (wistiaVideo) {
    if (isChecked) {
      wistiaVideo.time(0);
    } else {
      wistiaVideo.play();
    }
  }

  this.toggleAttribute("checked");
}
if (toggleSwitch) toggleSwitch.addEventListener("change", onCheckboxToggle);

$(document).ready(function () {
  $(".content-builder-content")
    .first()
    .find('[data-title="Attribute"]')
    .remove();
  $(".video-container").parents(".content-row").attr("id", "video-section");

  $(".product__media-list").on("init reInit afterChange", function () {
    $(".slick-slide").attr("role", "listitem");
  });

  function setSlideFocusState(event, slick, currentSlide) {
    $(".slick-slide").attr("aria-hidden", "true");
    $(".slick-slide")
      .find("a, button, input, select, textarea")
      .attr("tabindex", "-1");

    $(".slick-active").attr("aria-hidden", "false");
    $(".slick-active")
      .find("a, button, input, select, textarea")
      .attr("tabindex", "0");
  }

  $(".product__media-list").on(
    "init reInit afterChange",
    function (event, slick, currentSlide) {
      setSlideFocusState(event, slick, currentSlide);
    }
  );

  // Handle pagination dots
  function updatePaginationDots(currentSlide) {
    $(".product-media-pagination__dot").removeClass("active").attr("aria-selected", "false");
    $(".product-media-pagination__dot").eq(currentSlide).addClass("active").attr("aria-selected", "true");
  }

  // Initialize pagination dots on slider init
  $(".product__media-list").on("init", function(event, slick) {
    updatePaginationDots(slick.currentSlide || 0);
    $(".product-media-pagination").css("display", "flex");
  });

  // Update pagination dots on slide change
  $(".product__media-list").on("afterChange", function(event, slick, currentSlide) {
    updatePaginationDots(currentSlide);
  });

  // Handle pagination dot clicks
  $(document).on("click", ".product-media-pagination__dot", function() {
    const slideIndex = $(this).data("slide-index");
    $(".product__media-list").slick("slickGoTo", slideIndex);
  });

  $(".product__media-list").slick({
    infinite: true,
    dots: false,
    // asNavFor: '.thumbnail-list-slider',
    prevArrow: `<button type="button" class="slick-prev slick-arrow" aria-label="Previous">
                      <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="20" cy="20" r="20" transform="matrix(-1 0 0 1 40 0.5)" fill="#525150"/>
                        <path d="M22.6875 26.375L16.3125 20L22.6875 13.625" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                  </button>`,
    nextArrow: `<button type="button" class="slick-next slick-arrow" aria-label="Next">
                      <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="20" cy="20.5" r="20" fill="#525150"/>
                        <path d="M17.3125 26.375L23.6875 20L17.3125 13.625" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>`,
    responsive: [
      {
        breakpoint: 989,
        settings: {
          arrows: false
        }
      }
    ]
  });
  // Dynamically set slidesToShow based on actual number of items
  const thumbnailItems = $(
    ".thumbnail-list-slider .thumbnail-list__item"
  ).length;
  const slidesToShow = Math.min(3, thumbnailItems);

  // Set data attribute for CSS targeting
  $(".thumbnail-list-slider").attr("data-slides-count", thumbnailItems);

  $(".thumbnail-list-slider").slick({
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    // asNavFor: '.product__media-list',
    centerMode: false,
    focusOnSelect: true,
    infinite: true,
    centerPadding: 0,
  });

  // sticky sidebar
  stickSidebar();

  $(window).on("resize", function () {
    stickSidebar();
  });

  $(document).on("click", ".thumbnail-list__item", function () {
    let $this = $(this);
    let slick_index = $this.attr("data-slick-index");
    $(".product__media-list").slick("slickGoTo", slick_index);
  });

  function stickSidebar() {
    function evaluateSidebar() {
      var sectionHeight = $(".template-product .product").height() + 180;

      if ($(window).width() < 989) {
        sectionHeight = $(".template-product .product").height() + 300;
      }

      var scroll = $(window).scrollTop();
      var isFirstTabActive = $(
        ".product_submenu ul.tabs li:first-child"
      ).hasClass("current");

      if (isFirstTabActive) {
        if (scroll >= sectionHeight) {
          $(".product__info-wrapper").addClass("fixed");
          $(".sidebar-navigation-wrapper").removeClass("hidden");
        } else {
          $(".product__info-wrapper").removeClass("fixed");
          $(".sidebar-navigation-wrapper").addClass("hidden");
        }
      } else {
        $(".product__info-wrapper").removeClass("fixed");
        $(".sidebar-navigation-wrapper").addClass("hidden");
      }
    }

    // Run on scroll
    $(window).on("scroll", evaluateSidebar);

    // Run on tab click
    $(".product_submenu ul.tabs li").on("click", function () {
      setTimeout(evaluateSidebar, 10); // Delay to allow tab state to update
    });

    // Run on initial load
    evaluateSidebar();
  }

  // sticky info tab
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    var target = $(".product_submenu").length
      ? $(".product_submenu").offset().top - 50
      : 0;
    // var sectionHeight = $('.financing-section').offset().top - 265;

    // if (scroll >= target) {
    //   $('.product_submenu').addClass("fixed");
    // } else {
    //   $('.product_submenu').removeClass("fixed");
    // }

    var scrollPos = $(document).scrollTop() + 120; // considering the offset

    $(".tab-head .internal-link").each(function () {
      var currLink = $(this).attr("data-link");
      var target = $('[data-title="' + currLink + '"]');
      if (target != "" && target.length) {
        var refElement = target;
        var offsetTop = target.offset().top;
        var offsetBottom =
          offsetTop + refElement.next(".content-row").outerHeight();
        if (scrollPos >= offsetTop && scrollPos <= offsetBottom) {
          $(".tab").removeClass("tab--open");
          $('.internal-link[data-link="' + currLink + '"]')
            .parents(".tab")
            .addClass("tab--open");
          $(".internal-link").removeClass("active");
          // currLink.addClass('active');
        } else {
          // $('.tab').removeClass('tab--open');
          // $('.internal-link').removeClass('active');
        }
      }
    });
    $(".tab-body .internal-link").each(function () {
      var currLink = $(this).attr("data-link");
      var target = $('[data-subsection-title="' + currLink + '"]');
      if (target != "" && target.length) {
        var refElement = target;
        var offsetTop = target.offset().top;
        var offsetBottom =
          offsetTop + refElement.parents(".content-row").outerHeight();
        if (scrollPos >= offsetTop && scrollPos <= offsetBottom) {
          $(".internal-link").removeClass("active");
          $('.internal-link[data-link="' + currLink + '"]').addClass("active");
        } else {
          // $('.tab').removeClass('tab--open');
          // $('.internal-link').removeClass('active');
        }
      }
    });
  });

  // check image is dark or lignt start
  var thisImg;

  function getImageBrightness(image, callback) {
    var thisImgID = image.attr("id");
    var imageSrc = image.attr("src");

    if (!imageSrc || imageSrc === "undefined" || imageSrc === "null") {
      return;
    }

    var img = document.createElement("img");
    img.src = imageSrc;

    img.style.display = "none";
    document.body.appendChild(img);

    var colorSum = 0;

    img.onload = function () {
      // create canvas
      var canvas = document.createElement("canvas");
      canvas.width = this.width;
      canvas.height = this.height;

      var ctx = canvas.getContext("2d");
      ctx.drawImage(this, 0, 0);

      var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      var data = imageData.data;
      var r, g, b, avg;

      for (var x = 0, len = data.length; x < len; x += 4) {
        r = data[x];
        g = data[x + 1];
        b = data[x + 2];

        avg = Math.floor((r + g + b) / 3);
        colorSum += avg;
      }

      var brightness = Math.floor(colorSum / (this.width * this.height));
      callback(thisImgID, brightness);
    };
  }
  thisImg = $("img.full-background-image");

  if (
    thisImg.length > 0 &&
    thisImg.attr("src") &&
    thisImg.attr("src") !== "undefined"
  ) {
    getImageBrightness(thisImg, function (thisImgID, brightness) {
      if (brightness < 127.5) {
        $(`#MainProduct-${section_id}`).addClass("dark-bg");
      } else {
        $(`#MainProduct-${section_id}`).addClass("light-bg");
      }
    });
  }
  // check image is dark or lignt end

  // sidebar navigation
  $(document).on("click", ".internal-link", function (e) {
    e.preventDefault();
    var target = $(this).attr("data-link");
    console.log("target", target);

    if (target != "") {
      let count_subtabs = $(this)
        .closest(".tab")
        .find(".tab-inner ul li").length;
      let $target = $('[data-title="' + target + '"]');
      if (!$target.length) {
        $target = $('[data-subsection-title="' + target + '"]');
      }
      if ($target.length) {
        $("html, body")
          .stop()
          .animate(
            {
              scrollTop: $target.offset().top - 105,
            },
            400,
            "swing"
          );
      }
    }
  });

  $(document).on("click", ".more_view_description", function () {
    event.preventDefault();
    var target = this.hash;
    if (target != "") {
      var $target = $(target);
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $target.offset().top - 100,
          },
          400,
          "swing",
          function () {}
        );
    }
  });

  setTimeout(() => {
    $("#appliances-section").addClass("hidden");
  }, 5000);

  $(document).on("change", "#toggle_switch", function () {
    if ($(this).is(":checked")) {
      $("#appliances-section").removeClass("hidden");
      $("#area-of-application").addClass("hidden");
    } else {
      $("#area-of-application").removeClass("hidden");
      $("#appliances-section").addClass("hidden");
    }
  });

  $(".product__info-wrapper button.close-desc").on("click", function () {
    $(".product__info-wrapper product-info").css("z-index", "-1");
    $(".media-container").addClass("no-overlay");
  });

  // The sidebar navigation is built from the rendered content-builder rows. An AICO neo
  // document (assets/aico-neo-entity.js) may still be painting when this runs (its URL
  // path fetches), so wait for it; without neo the build runs exactly as before.
  function buildContentSidebarNavigation() {
    let count_r = 0;
    $(".row-translated-title[data-title], .content-builder-content .content-row").each(function (i) {
      var $this = $(this);
      var data_title = $this.attr("data-title");

      if (data_title) {
        count_r = 0;
      } else {
        count_r++;
      }

      var headTab_data = $this.next(".content-row").find(".content-column");
      var has_headTab_data = false;

      for (var t = 0; t < headTab_data.length; t++) {
        if (headTab_data[t].innerText.trim() !== "" || headTab_data[t].innerHTML.trim() !== "") {
          has_headTab_data = true;
        }
      }

      const sidebar = document.querySelector(".sidebar-navigation-wrapper-inner");
      const tabsContainer = sidebar?.querySelector(".tabs");

      if (!sidebar || !tabsContainer) {
        console.warn("Sidebar or tabs container not found");
        return;
      }

      var subTab = "";
      if (data_title) {
        let subTabInner = "";

        $this.next(".content-row").find("[data-subsection-title]").each(function () {
          var attr = $(this).attr("data-subsection-title");
          var text = this.innerText.trim();


          if (text && attr && attr.trim() !== "") {
            subTabInner += `<li><a href="#" data-link="${attr}" class="internal-link sublink">${attr}</a></li>`;
          }
        });

        if (subTabInner !== "") {
          subTab = `
            <div class="tab-body has-row-title">
              <div class="tab-inner">
                <ul>${subTabInner}</ul>
              </div>
            </div>`;
        }

        var html = `
          <div class="tab${i === 0 ? " tab--open" : ""}">
            <div class="tab-head">
              <a href="#" data-link="${data_title}" class="internal-link mainlink">${data_title}</a>
            </div>
            ${subTab}
          </div>`;

        if (has_headTab_data) {
          tabsContainer.insertAdjacentHTML("beforeend", html);
        }

      } else if (count_r > 1) {

        $this.find("[data-subsection-title]").each(function () {
          var attr = $(this).attr("data-subsection-title");
          var text = this.innerText.trim();

          if (text && attr && attr.trim() !== "") {
            subTab += `<li><a href="#" data-link="${attr}" class="internal-link">${attr}</a></li>`;
          }
        });

        const lastTabList = sidebar.querySelector(".tabs .tab:last-of-type .tab-body ul");

        if (lastTabList) {
          lastTabList.insertAdjacentHTML("beforeend", subTab);
        } else {
          if (subTab !== "") {
            const newTabBody = `
            <div class="tab-body has-row-title">
              <div class="tab-inner">
                <ul>${subTab}</ul>
              </div>
            </div>`;
            const lastTab = sidebar.querySelector(".tabs .tab:last-of-type");
            if (lastTab) {
              lastTab.insertAdjacentHTML("beforeend", newTabBody);
            }
          }
          else{
            console.warn("Last tab list not found");
          }
        }
      }
    });

    let experiencesTabTitle =
      `${current_lang}` == "de_ch"
        ? "Bewertungen & Erfahrungen"
        : "Évaluations & expériences";
    let reviewsTabTitle =
      `${current_lang}` == "de_ch"
        ? "Kundenbewertungen"
        : "Témoignages de clients";

    let sidebarWrapper = document.querySelector(
      ".sidebar-navigation-wrapper-inner"
    );
    let experiences = sidebarWrapper.querySelector(
      `[data-link='${experiencesTabTitle}']`
    );
    let userReviews = sidebarWrapper.querySelector(
      `[data-link='${reviewsTabTitle}']`
    );

    if (experiences && userReviews) {
      let replacement = `<li><a href="#" data-link="${reviewsTabTitle}" class="internal-link">${reviewsTabTitle}</a></li>`;

      // experiences.closest(".tab").querySelector(".tab-inner ul").insertAdjacentHTML("afterbegin", replacement);
      experiences
        .closest(".tab")
        .querySelector(".tab-inner ul")
        .insertAdjacentHTML("beforeend", replacement);
      userReviews.remove();
    }

    let count_row = $(".row-translated-title[data-title]").length;
    if (count_row == 0) {
      $(".sidebar-navigation-wrapper").hide();
    }
  }

  var pendingNeo = document.querySelector("[data-aico-neo-mount][data-aico-neo-pending]");
  if (pendingNeo) {
    var sidebarBuilt = false;
    var buildOnce = function () {
      if (sidebarBuilt) return;
      sidebarBuilt = true;
      buildContentSidebarNavigation();
    };
    document.addEventListener("aico-neo:entity-rendered", buildOnce, { once: true });
    setTimeout(buildOnce, 10000);
  } else {
    buildContentSidebarNavigation();
  }

  $(document).on("click", ".tabs .tab .tab-head", function () {
    $(".tabs .tab").removeClass("tab--open");
    $(this).closest(".tab").addClass("tab--open");
  });

  $(document).on("click", ".button-show_side_navigation", function () {
    $(this).toggleClass("open_sidenav_btn");
    $(".sidebar-navigation-wrapper").toggleClass("sidebar-navigation-open");
  });
});

// Initialize lightbox functionality
initLightbox();

$(document).on("change", ".custom-meta-dropdown .select__select", function () {
  var product_url = $(this).find("option:selected").data("url");
  if (
    product_url &&
    product_url !== "undefined" &&
    product_url.indexOf("undefined") === -1
  ) {
    window.location.href = product_url;
  }
});

$(document).ready(function () {
  const updateTotalLiWidth = () => {
    const listItems = $(".product_submenu ul.tabs li:not(.hidden)");
    let totalWidth = 0;

    listItems.each((index, element) => {
      totalWidth += $(element).outerWidth(true);
    });

    $(".product_submenu ul.tabs")
      .css("--total-li-width", `${totalWidth}px`)
      .addClass("totalWidth-get");
  };
  setTimeout(() => {
    updateTotalLiWidth();
  }, 500);

  // Optional: Update on resize with debounce to improve performance
  let resizeTimer;
  $(window).on("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateTotalLiWidth, 250);
  });
});
